module.exports = __webpack_public_path__ + "static/media/floor.3b5d448c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/characteristics/floor.svg
// module id = 867
// module chunks = 0